import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import FullPageLayout from "../../components/FullPageLayout/FullPageLayout";
import { SitePage } from "../../types/SitePage";

import { Button } from "react-bootstrap";
import { useAppAuthState } from "../../hooks/use-app-auth-state";
import "./AboutPage.scss";

const AboutPage: React.FC = () => {
  const { isLoggedIn, isAuthLoading } = useAppAuthState();
  const navigate = useNavigate();

  const handleLoginClick = useCallback(() => {
    navigate("/login");
  }, [navigate]);

  const handleRegisterClick = useCallback(() => {
    navigate("/register");
  }, [navigate]);

  return (
    <FullPageLayout page={SitePage.About} title="About">
      <div className="d-flex justify-content-center align-items-center h-100 w-100">
        <div className="box">
          <div className="box-content">
            Creating connections between founders and investors.
          </div>
          <div className="box-content">
            Helping startups in their full lifecycle.
          </div>
          {!isAuthLoading && (
            <>
              {isLoggedIn ? (
                <div className="box-footer">
                  <Button
                    variant="primary"
                    className="btn-lg"
                    onClick={handleLoginClick}
                  >
                    Home
                  </Button>
                </div>
              ) : (
                <div className="box-footer">
                  <Button
                    variant="primary"
                    className="btn-lg"
                    onClick={handleLoginClick}
                  >
                    Login
                  </Button>
                  <Button
                    variant="primary"
                    className="btn-lg"
                    onClick={handleRegisterClick}
                  >
                    Register
                  </Button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </FullPageLayout>
  );
};

export default AboutPage;
